import { MobXProviderContext } from "mobx-react";
import { useContext, useEffect, useState } from "react";
import { AuthExperienceConfig, DEFAULT_AUTH_EXPERIENCE } from "../config/authExperience";
import { getSessionBrandOverride } from "../config/brandOverride";

export const useAuthExperience = () => {
  const { backendAPIStore } = useContext(MobXProviderContext);
  const [authExperience, setAuthExperience] = useState<AuthExperienceConfig>(DEFAULT_AUTH_EXPERIENCE);

  useEffect(() => {
    let isMounted = true;

    const loadAuthExperience = async () => {
      try {
        const response = await backendAPIStore.getPublicAuthExperience(window.location.host, getSessionBrandOverride());
        if (isMounted && response) {
          setAuthExperience(response);
        }
      } catch (error) {
        if (isMounted) {
          setAuthExperience(DEFAULT_AUTH_EXPERIENCE);
        }
      }
    };

    void loadAuthExperience();

    return () => {
      isMounted = false;
    };
  }, [backendAPIStore]);

  return authExperience;
};
